import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=05bc9554&scoped=true&"
import script from "./Table.vue?vue&type=script&setup=true&lang=js&"
export * from "./Table.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Table.vue?vue&type=style&index=0&id=05bc9554&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bc9554",
  null
  
)

export default component.exports